import React from 'react';
import { Button } from './Button';
export function PersuasiveCTA() {
  return <section className="py-6 px-4 bg-brand-dark" data-id="element-97">
      <div className="max-w-xl mx-auto" data-id="element-98">
        <Button className="text-lg py-4" data-id="element-99">
          ⚡ SÍ, QUIERO DEJAR DE IMPROVISAR →
        </Button>
      </div>
    </section>;
}